import { Navigate, NavLink, Outlet } from 'react-router-dom'
import { Activity, CalendarDays, CalendarRange, Copy, Hash, Palette, Sliders } from 'lucide-react'
import { useAuth } from '@/context/AuthContext'
import { canManageHrSettings } from '@/features/hr/access'

const HR_TABS = [
  { key: 'leave-types', label: 'Leave Policy', href: '/app/settings/hr/leave-types', icon: CalendarRange },
  { key: 'holidays', label: 'Holiday Calendar', href: '/app/settings/hr/holidays', icon: CalendarDays },
  { key: 'branding', label: 'Letterhead Branding', href: '/app/settings/hr/branding', icon: Palette },
  { key: 'templates', label: 'Document Templates', href: '/app/settings/hr/templates', icon: Copy },
  { key: 'employee-codes', label: 'Employee Code Series', href: '/app/settings/hr/employee-codes', icon: Hash },
  { key: 'performance', label: 'Performance & Incentives', href: '/app/settings/hr/performance', icon: Sliders },
  { key: 'activity-targets', label: 'Activity Targets', href: '/app/settings/hr/activity-targets', icon: Activity },
]

/**
 * Settings > HR. Only owners, super admins and Admins of the HR department get in; everyone else is sent
 * back to the settings overview. (The API enforces the same rule - this just keeps the page out of sight.)
 */
export default function HrSettingsLayout() {
  const { user, isLoading } = useAuth()
  if (isLoading) return null
  if (!canManageHrSettings(user)) return <Navigate to="/app/settings" replace />

  return (
    <div className="space-y-5">
      <div className="border-b border-border pb-2.5 overflow-x-auto no-scrollbar">
        <div className="flex items-center gap-1.5 min-w-max">
          {HR_TABS.map((tab) => (
            <NavLink
              key={tab.key}
              to={tab.href}
              className={({ isActive }) =>
                `flex items-center gap-2 px-3 py-1.5 text-xs font-semibold rounded-lg transition-all ${
                  isActive
                    ? 'bg-primary text-primary-foreground shadow-2xs'
                    : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                }`
              }
            >
              <tab.icon className="h-3.5 w-3.5 shrink-0" />
              <span>{tab.label}</span>
            </NavLink>
          ))}
        </div>
      </div>
      <div className="min-w-0">
        <Outlet />
      </div>
    </div>
  )
}
